import React, { useState, useContext, useEffect } from "react";
import { AppStateContext, AppConfig } from "../../../app-state";
import { useHistory, Link } from "react-router-dom";
import { AppLoad } from "../../../core/AppLoad";
import { Spinner } from "../../../core/Spinner";
import { Icon } from "../../../core/Icon";
export const SignOut = (props) => {
    const { state, dispatch } = useContext(AppStateContext);
    const [signOutPending, setSignOutPending] = useState(true);
    let history = useHistory();
    const SignOut = () => {
        AppLoad(AppConfig.APIUrl + 'public/auth/SignOut').then((Response) => {
            if (Response.status == 'ok') {
                dispatch({ type: 'signOut' });
                setSignOutPending(false);
            }
        });
    };
    useEffect(SignOut, []);
    return (React.createElement("div", { className: "process-master-challenge text-center" }, signOutPending ? React.createElement(Spinner, { large: true }) :
        React.createElement("div", { className: "" },
            React.createElement("div", null,
                React.createElement(Icon, { c: ['user', 64, 64, 'success-icon'] }),
                React.createElement("h1", { className: "mb-8" }, "Odhl\u00E1\u0161en\u00ED prob\u011Bhlo \u00FAsp\u011B\u0161n\u011B"),
                React.createElement("p", null, "M\u016F\u017Eete zav\u0159\u00EDt okno prohl\u00ED\u017Ee\u010De nebo pokra\u010Dovat v proch\u00E1zen\u00ED."),
                React.createElement(Link, { className: "primary-button", to: "/cs/seznam/nejblizsi-aukce" }, "Pokra\u010Dovat na \u00FAvodn\u00ED stranu")))));
};
